<template>
	<div>
		<div v-if="isFirst">
			<div>
				<el-row :gutter="12">
				  <el-col :span="8">
				    <div>
				    	<el-card shadow="hover">
					      	<el-row>
							      <el-col :span="4">
							      	<img src="../../assets/images/用户.png"/>
							      </el-col>
							      <el-col :span="10">
								      <div style="text-align: center;width: 100%;">
								      	<div>
							      			{{totalUser}}人
							      		</div>
							      		<div>
							      			客户总数
							      		</div>
							    		</div>
							      </el-col>
							    </el-row>
					    </el-card>
				    </div>
				  </el-col>
				  <el-col :span="8">
				  	<div>
				  		<el-card shadow="hover">
					      	<el-row>
							      <el-col :span="4">
							      	<img src="../../assets/images/钱包.png"/>
							      </el-col>
							      <el-col :span="10">
								      <div style="text-align: center;width: 100%;">
								      	<div>
							      			{{money}}元
							      		</div>
							      		<div>
							      			订单消费
							      		</div>
							    		</div>
							      </el-col>
							    </el-row>
					    </el-card>
				  	</div>
				  </el-col>
				</el-row>
			</div>
			<div style="margin-top: 15px;text-align: right;">
				<div>
					<el-input v-model="userNickname" style="width: 200px;" placeholder="搜索用户名"></el-input>
					<el-button @click="queryTable" style="margin-left: 3px;">搜索</el-button>
				</div>
			</div>
			<div style="margin-top: 25px;">
				<el-table ref="multipleTable"
					 :data="tableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="handleSelectionChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column prop="uid" label="客户ID" sortable></el-table-column>
			      <el-table-column prop="nickname" label="姓名"></el-table-column>
			      <el-table-column prop="agentName" label="代理商"></el-table-column>
			      <el-table-column prop="phone" label="手机号"></el-table-column>
			      <el-table-column prop="totalDevice" label="设备总数"></el-table-column>
			      <el-table-column prop="consumption" label="订单消费"></el-table-column>
			      <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<button @click="checkChild(scope.row)">查看</button>
			      	</template>
			      </el-table-column>
			    </el-table>
			    <el-pagination background
		    			style="text-align:right;margin-top: 15px;"
			            @size-change="handleSizeChange"
			            @current-change="handleCurrentChange"
			            :current-page="currentPage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="pageSize"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total">
			    </el-pagination>
			</div>
		</div>
		<div v-if="!isFirst">
			<div style="margin-top: 15px;">
				<i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">订单发货</i>
			</div>
			<div style="margin-top: 10px;">
				<span style="font-size: 24px;">客户名:{{nickname}}</span>
			</div>
			<div>
				<table style="margin-top: 5px;font-size: 12px;">
					<tr>
						<td>联系电话:</td>
						<td><span>{{phone}}</span></td>
					</tr>
					<tr>
						<td>直属代理商:</td>
						<td><span>{{agentName}}</span></td>
					</tr>
				</table>
			</div>
			<div style="margin-top: 25px;">
				<el-table ref="orderTable"
					 :data="orderData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="orderTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column label="类型">
			      	<template  slot-scope="scope">
			      		<span v-if="scope.row.merchInfoRO.merchType == 1">激活码</span>
			      		<span v-if="scope.row.merchInfoRO.merchType == 2">配件</span>
			      		<span v-if="scope.row.merchInfoRO.merchType == 3">租赁商品</span>
			      		<span v-if="scope.row.merchInfoRO.merchType == 4">饮水机</span>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="merchInfoRO.name" label="商品名" sortable></el-table-column>
			      <el-table-column prop="merchInfoRO.quanlity" label="数量"></el-table-column>
			      <el-table-column prop="amount" label="总价"></el-table-column>
			      <el-table-column prop="deliveryInfo.receiver" label="收件人"></el-table-column>
			      <el-table-column prop="deliveryInfo.tel" label="联系电话"></el-table-column>
			      <el-table-column prop="deliveryInfo.address" label="地址"></el-table-column>
			      <el-table-column prop="paytime" label="付款时间" :formatter="dateFormat"></el-table-column>
			      <el-table-column prop="orderId" label="订单号"></el-table-column>
			      <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<button @click="getMessage(scope.row)">查看</button>
			      	</template>
			      </el-table-column>
			    </el-table>
			    <el-pagination background
		    			style="text-align:right;margin-top: 15px;"
			            @size-change="orderSizeChange"
			            @current-change="orderCurrentChange"
			            :current-page="orderPage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="orderSize"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="orderTotal">
			    </el-pagination>
			</div>
			<div style="margin-top: 25px;">
				<el-table ref="deviceTable"
					 :data="deviceData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="deviceTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column prop="nid" label="设备NID" sortable></el-table-column>
			      <el-table-column prop="name" label="设备类型名"></el-table-column>
			      <el-table-column prop="activationCode" label="激活码"></el-table-column>
			      <el-table-column prop="activationDate" label="激活时间" :formatter="dateFormat"></el-table-column>
			      <el-table-column prop="activationCode" label="到期时间" :formatter="dateFormat"></el-table-column>
			      <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<button @click="getMessage(scope.row)">查看</button>
			      	</template>
			      </el-table-column>
			    </el-table>
			    <el-pagination background
		    			style="text-align:right;margin-top: 15px;"
			            @size-change="deviceSizeChange"
			            @current-change="deviceCurrentChange"
			            :current-page="devicePage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="deviceSize"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="deviceTotal">
			    </el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'userManagement',
  components: {
  },
  data() {
    return {
    	total: 0,
      currentPage: 1,
　　  	pageSize: 10,
			multipleSelection:[],
			totalUser:0,
			money:0,
			tableData:[],
			userNickname:"",
			nickname:"",
			agentName:"",
			phone:"",
			orderTotal: 0,
      orderPage: 1,
　　  	orderSize: 10,
			orderSelection:[],
			orderData:[],
			deviceTotal: 0,
      devicePage: 1,
　　  	deviceSize: 10,
			deviceSelection:[],
			deviceData:[],
			isFirst:true
    }
  },
  watch: {
  },
  mounted() {
  	this.initPage();
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	initPage(){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/srsCustomer/customerOverview.do')
    		.then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.totalUser = data.data.totalUser;
			    	thiz.money = data.data.totalConsumption;
			    }
			}).catch(function (error) {
			    console.log(error);
			});
  	},
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    orderTableChange(val) {
      this.orderSelection = val;
    },
  	orderSizeChange(val) {
      this.orderSize = val;
      this.updateOrder();
    },
    orderCurrentChange(val) {
      this.orderPage = val;
      this.updateOrder();
    },
    deviceTableChange(val) {
      this.deviceSelection = val;
    },
  	deviceSizeChange(val) {
      this.deviceSize = val;
      this.updateDevice();
    },
    deviceCurrentChange(val) {
      this.devicePage = val;
      this.updateDevice();
    },
  	headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
		},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
		},
  	updateTable(){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/srsCustomer/getCustomerList.do',{
  			params:{
  				pageId:thiz.currentPage,
  				size:thiz.pageSize
  			}
  		}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.total = data.totalCount;
		    		thiz.tableData = data.data;
			    }
			}).catch(function (error) {
			    console.log(error);
			});
  	},
  	queryTable(){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/srsCustomer/searchCustomerList.do',{
  			params:{
  				pageId:thiz.currentPage,
  				size:thiz.pageSize,
  				nickname:thiz.userNickname
  			}
  		}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.total = data.totalCount;
		    		thiz.tableData = data.data;
			    }
			}).catch(function (error) {
			    console.log(error);
			});
  	},
  	checkChild(row){
  		this.nickname = row.nickname;
  		this.agentName = row.agentName;
  		this.phone = row.phone;
  		this.updateOrder(row.uid);
  		this.updateDevice(row.uid);
  		this.isFirst = false;
  	},
  	dateFormat(row,column){
			var str = row[column.property];
			if(str == null || str == ""){
				return "";
			}else{
				var data = new Date(str);
				var year = data.getFullYear();
				var month = data.getMonth()+1;
				var day = data.getDate();
				month = month < 10 ? "0"+month : month;
				day = day < 10 ? "0"+day : day;
				return year+"-"+month+"-"+day;
			}
		},
  	goback(){
  		this.isFirst = true;
  	},
  	getMessage(row){
  		console.log(row)
  	},
  	updateOrder(uid){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/srsCustomer/searchCustomerOrderList.do',{
  			params:{
  				pageId:thiz.orderPage,
  				size:thiz.orderSize,
  				type:-1,
  				uid:uid
  			}
  		}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.orderTotal = data.totalCount;
		    		thiz.orderData = data.data;
			    }
			}).catch(function (error) {
			    console.log(error);
			});
  	},
  	updateDevice(uid){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/srsCustomer/searchCustomerDeviceList.do',{
  			params:{
  				pageId:thiz.devicePage,
  				size:thiz.deviceSize,
  				touid:uid
  			}
  		}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.deviceTotal = data.totalCount;
		    		thiz.deviceData = data.data;
			    }
			}).catch(function (error) {
			    console.log(error);
			});
  	}
  }
}
</script>

<style>
	.el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>
